import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fiTelHref',
    standalone: false,
})
export class TelHrefPipe implements PipeTransform {
    transform(value: any, args?: any): any {
        return value ? value.replace(/[^\d+]/g, '') : '';
    }
}
